export var RevaluationType;
(function (RevaluationType) {
    RevaluationType["Revaluation"] = "REVALUATION";
    RevaluationType["InitialInvestment"] = "INITIAL_INVESTMENT";
})(RevaluationType || (RevaluationType = {}));
export var RevaluationTransactionType;
(function (RevaluationTransactionType) {
    RevaluationTransactionType["CompanyRevaluationUp"] = "companyRevaluationUp";
    RevaluationTransactionType["CompanyRevaluationDown"] = "companyRevaluationDown";
})(RevaluationTransactionType || (RevaluationTransactionType = {}));
//# sourceMappingURL=index.js.map